import { AppRole, OnboardingStatus } from 'api/types/user';
import MenuBar from 'components/dumb/atomics/MenuBar';
import { AppMode } from 'helpers/constants/enums';
import { useAppSelector } from 'hooks/redux';
import {
  appModeSelector,
  appViewRole,
  authUserMessagesCount,
  authUserNewsCount,
  authUserOnboardingIsSkipedSelector,
  authUserOnboardingStatusSelector,
} from 'redux/slices/selectors';
import PATH from 'routes/paths';
import useInAppNavigate from '../../../../hooks/useInAppNavigate';

interface MenuBarProps {
  onMenuClick: CallbackFunction;
}

export default function ConnectedMenuBar({ onMenuClick }: MenuBarProps) {
  const { navigate } = useInAppNavigate();

  const appRole = useAppSelector(appViewRole);
  const isOnboardingSkipped = useAppSelector(
    authUserOnboardingIsSkipedSelector
  );
  const onboardingStatus = useAppSelector(authUserOnboardingStatusSelector);
  const userMessagesCount = useAppSelector(authUserMessagesCount);
  const userNewsCount = useAppSelector(authUserNewsCount);
  const appModeView = useAppSelector(appModeSelector);

  const isBusinessMode = appModeView.appMode === AppMode.BUSINESS;

  const handleNavigateMindFeed = () => {
    const targetPath = isBusinessMode
      ? PATH.BUSINESS.MIND_FEED
      : PATH.MIND_FEED;

    navigate(targetPath);
  };
  const handleNavigateMarketplace = () => {
    const targetPath = isBusinessMode ? PATH.INDEX : PATH.INDIVIDUAL_INDEX;

    navigate(targetPath);
  };
  const handleStarClick = () => {
    if (appRole === AppRole.ContentCreator) {
      navigate(PATH.EXMINDER.MY_EXPERIENCES);
    } else {
      navigate(PATH.EXPLORER.MY_EXPERIENCES);
    }
  };

  return (
    <MenuBar
      isExminder={appRole === AppRole.ContentCreator}
      isOnboardingSkipped={
        isOnboardingSkipped &&
        onboardingStatus !== OnboardingStatus.ProfilePictureSet
      }
      notificationsCount={userMessagesCount + userNewsCount}
      onMenuClick={onMenuClick}
      onMindFeedClick={handleNavigateMindFeed}
      onNotificationClick={() => {
        navigate(PATH.NOTIFICATIONS.NEWS);
      }}
      onMarketplaceClick={handleNavigateMarketplace}
      onStarClick={handleStarClick}
      onBuildProfile={() => navigate(PATH.ONBOARDING.CHAT)}
    />
  );
}
